var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassDialog",
    {
      attrs: {
        primaryAction: {
          label: _vm.$t.__(
            "sellsyaccountmanager.SubscriptionManager.CancelSubscriptionCancellationDialog.confirmBtn"
          ),
          action: _vm.onValidate,
          loading: _vm.loading
        },
        secondaryActions: [
          {
            label: _vm.$t.__("common.actions.cancel"),
            action: _vm.handleClose
          }
        ],
        title: _vm.$t.__(
          "sellsyaccountmanager.SubscriptionManager.CancelSubscriptionCancellationDialog.title"
        ),
        visible: _vm.visible,
        size: "small"
      },
      on: {
        "update:visible": function($event) {
          _vm.visible = $event
        },
        closed: _vm.handleClose
      }
    },
    [
      _c("div", { staticClass: "typographies-paragraph-medium-regular" }, [
        _vm._v(
          "\n        " +
            _vm._s(
              _vm.$t.__(
                "sellsyaccountmanager.SubscriptionManager.CancelSubscriptionCancellationDialog.content"
              )
            ) +
            "\n    "
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }